export default {
      id: "checkbox_bold-usage",
      viewBox: "0 0 12 10",
      url: __webpack_public_path__ + "img/icons.svg#checkbox_bold",
      toString: function () {
        return this.url;
      }
    }